import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

/*
 * Type definitions
 */
const propTypes = {
    tradingHours: PropTypes.string.isRequired,
};

/*
 * Component
 */
function TradingHoursToday({ tradingHours }) {
    if (!tradingHours) {
        return null;
    }

    return (
        <div className="trading-hours-today">
            <span>Today</span>
            {tradingHours}
        </div>
    );
}

TradingHoursToday.propTypes = propTypes;

export default TradingHoursToday;
